import React, { ChangeEvent } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import styled from "styled-components";
import { Common } from "../../styles/Common";
import MgInput from "../../components/input/MgInput";
import { useSignupExpertStore, OfficeInfo } from "@src/store/signupExpertStore";

const WriteOffice = () => {
    const navigate = useNavigate();
    const { form, setPartialState } = useSignupExpertStore();

    const handleChange =
        <K extends keyof OfficeInfo>(key: K) =>
        (e: ChangeEvent<HTMLInputElement>) => {
            setPartialState({
                form: {
                    ...form,
                    officeInfo: {
                        ...(form.officeInfo ?? ({} as OfficeInfo)),
                        [key]: e.currentTarget.value,
                    },
                },
            });
        };

    const handleClick = () => {
        navigate("/signup/locationSearch");
    };

    const handleComplete = () => {
        navigate(-1);
    };

    // 모든 필수값이 입력되었는지 체크
    const isActive =
        !!form.officeInfo?.ceo?.trim() &&
        !!form.officeInfo?.name?.trim() &&
        !!form.officeInfo?.phone?.trim() &&
        !!form.officeInfo?.registrationNumber?.trim() &&
        !!form.officeInfo?.address?.trim();

    return (
        <Location_Layout>
            <Header title="중개사무소 입력" />
            <Location_Container>
                <InputBox>
                    <InputHeader>
                        <div className="star">*</div>
                        <div className="title">대표자 성함</div>
                    </InputHeader>
                    <MgInput
                        width="336px"
                        value={form.officeInfo?.ceo}
                        onChange={handleChange("ceo")}
                        placeholder="대표자 성함 입력"
                        noBorder
                        bgColor="#F4F4F4"
                    />
                </InputBox>

                <InputBox>
                    <InputHeader>
                        <div className="star">*</div>
                        <div className="title">중개사무소명</div>
                    </InputHeader>
                    <MgInput
                        width="336px"
                        value={form.officeInfo?.name}
                        onChange={handleChange("name")}
                        placeholder="중개사무소명 입력"
                        noBorder
                        bgColor="#F4F4F4"
                    />
                </InputBox>

                <InputBox>
                    <InputHeader>
                        <div className="star">*</div>
                        <div className="title">연락처</div>
                    </InputHeader>
                    <MgInput
                        width="336px"
                        value={form.officeInfo?.phone}
                        onChange={handleChange("phone")}
                        placeholder="연락처 입력"
                        noBorder
                        bgColor="#F4F4F4"
                    />
                </InputBox>

                <InputBox>
                    <InputHeader>
                        <div className="star">*</div>
                        <div className="title">등록번호</div>
                    </InputHeader>
                    <MgInput
                        width="336px"
                        value={form.officeInfo?.registrationNumber}
                        onChange={handleChange("registrationNumber")}
                        placeholder="등록번호 입력"
                        noBorder
                        bgColor="#F4F4F4"
                    />
                </InputBox>

                <InputBox>
                    <InputHeader>
                        <div className="star">*</div>
                        <div className="title">소재지</div>
                    </InputHeader>
                    <div onClick={handleClick}>
                        <MgInput
                            value={form.officeInfo?.address}
                            onChange={() => {}}
                            placeholder="조회하여 입력 가능합니다"
                            readOnly
                            noBorder
                            bgColor="#F4F4F4"
                        />
                    </div>
                </InputBox>

                <Footer>
                    <BtnStyle
                        className={`${isActive ? "active" : ""}`}
                        disabled={!isActive}
                        onClick={isActive ? handleComplete : undefined}
                    >
                        완료
                    </BtnStyle>
                </Footer>
            </Location_Container>
        </Location_Layout>
    );
};

export default WriteOffice;

const Location_Layout = styled.div``;

const Location_Container = styled.div`
    padding: 24px;
`;

const InputBox = styled.div`
    margin-bottom: 24px;
`;

const InputHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    margin-bottom: 8px;
    .star {
        color: ${Common.colors.notiColor};
    }
    .title {
        color: ${Common.colors.normalTextColor};
        font-size: 16px;
        font-weight: 400;
        line-height: 140%;
    }
`;

const Footer = styled.div`
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    padding: 24px;
`;

const BtnStyle = styled.button`
    margin-top: 24px;
    padding: 12px 14px;
    gap: 10px;
    width: 100%;
    border-radius: 12px;
    background: #c3c3c3;
    border: 1px solid #c3c3c3;
    color: #ffffff;
    font-weight: 400;
    font-size: 18px;
    cursor: pointer;

    &.active {
        background: ${Common.colors.aucMarkerColor};
        border: 1px solid ${Common.colors.aucMarkerColor};
        color: #ffffff;
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.8;
    }

    @media screen and (max-width: 768px) {
        width: 100%;
        margin-top: 14px;
        margin-bottom: 60px;
    }
`;
